import { render, staticRenderFns } from "./Expander.vue?vue&type=template&id=f92476da"
import script from "./Expander.vue?vue&type=script&lang=js"
export * from "./Expander.vue?vue&type=script&lang=js"
import style0 from "./Expander.vue?vue&type=style&index=0&id=f92476da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports